import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const usePasskeySettingCompelete = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { accessToken } = state ?? {};

  useEffect(() => {
    if (!accessToken) return navigateToPage(PageRoutes.LOGIN);

    LocalStorageManager.Instance.saveObject(
      AppConfig.Instance.LocalStorageKey["accessToken"],
      accessToken,
    );
  }, [accessToken]);

  const handlePasskeySettingComplete = useCallback(() => {
    dispatch(authActions.setIsLoggedIn(true));

    navigateToPage(PageRoutes.HOME);
  }, []);

  return { handlePasskeySettingComplete };
};
